var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_account_box"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_3447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_box",
    d: "M4.99997 18.0423C5.89998 17.159 6.94581 16.4632 8.13748 15.9548C9.32914 15.4465 10.6166 15.1923 12 15.1923C13.3833 15.1923 14.6708 15.4465 15.8625 15.9548C17.0541 16.4632 18.1 17.159 19 18.0423V5.30772C19 5.23079 18.9679 5.16027 18.9038 5.09615C18.8397 5.03205 18.7692 5 18.6923 5H5.3077C5.23077 5 5.16024 5.03205 5.09612 5.09615C5.03202 5.16027 4.99997 5.23079 4.99997 5.30772V18.0423ZM12 13.0385C12.9025 13.0385 13.6698 12.7224 14.3019 12.0904C14.9339 11.4583 15.25 10.691 15.25 9.78847C15.25 8.88592 14.9339 8.11862 14.3019 7.48657C13.6698 6.85452 12.9025 6.5385 12 6.5385C11.0974 6.5385 10.3301 6.85452 9.69808 7.48657C9.06603 8.11862 8.75 8.88592 8.75 9.78847C8.75 10.691 9.06603 11.4583 9.69808 12.0904C10.3301 12.7224 11.0974 13.0385 12 13.0385ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30772C3.5 4.80259 3.675 4.37502 4.025 4.02502C4.375 3.67502 4.80257 3.50002 5.3077 3.50002H18.6923C19.1974 3.50002 19.625 3.67502 19.975 4.02502C20.325 4.37502 20.5 4.80259 20.5 5.30772V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM6.44225 19H17.5577V18.7885C16.768 18.0833 15.9016 17.5577 14.9587 17.2115C14.0157 16.8654 13.0295 16.6923 12 16.6923C10.9833 16.6923 10.0019 16.8638 9.05573 17.2067C8.10956 17.5497 7.2384 18.0705 6.44225 18.7692V19ZM12 11.5385C11.5192 11.5385 11.1073 11.367 10.7644 11.0241C10.4214 10.6811 10.25 10.2693 10.25 9.78847C10.25 9.30771 10.4214 8.89585 10.7644 8.5529C11.1073 8.20995 11.5192 8.03847 12 8.03847C12.4807 8.03847 12.8926 8.20995 13.2356 8.5529C13.5785 8.89585 13.75 9.30771 13.75 9.78847C13.75 10.2693 13.5785 10.6811 13.2356 11.0241C12.8926 11.367 12.4807 11.5385 12 11.5385Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox);
export default __webpack_public_path__ + "static/media/account_box.9e725f5020c73f2a483a961f19437532.svg";
export { ForwardRef as ReactComponent };